import React, {useEffect} from 'react';
import BaseContainer from "../containers/common/BaseContainer";
import { useRecoilValue } from "recoil";
import {userState} from "../state/globalState";
import ResultMailForm from "../containers/ResultMailForm";


const ResultMailPage = ({ history }) => {
    const userInfo = useRecoilValue(userState);

    useEffect(() => {
        // if (userInfo.admnNo) {
        //     if (userInfo.surveyYn === "0") {
        //         history.push("/agree");
        //     }
        // }
    }, []);

    return (
        <>
            <BaseContainer sidebar={true}>
                <ResultMailForm />
            </BaseContainer>
        </>
    )
};

export default ResultMailPage;
